import { useMemo } from "react";
import {
  TextField,
  DatagridConfigurable,
  useTheme,
  NumberField,
} from "react-admin";
import getFirstAndLastDateOfCurrentMonth from "../../utils/firstLastDate";
import DownloadAction from "../../components/tableListActions/DownloadActionNew";
import accountReceivableHistoryFilterList from "../../components/accountReceivableHistories/filter/accountReceivableHistoryFilterList";
import AccountReceivableHistoryExpandList from "../../components/accountReceivableHistories/expand/AccountReceivableHistoryExpandList";
import MyDatagridBody from "../../components/common/MyDatagridBody";
import AccountReceivableHistoryFooterList from "../../components/accountReceivableHistories/footer/AccountReceivableHistoryFooterList";
import useCompanyScopedListFilters from "../../hooks/useCompanyScopedListFilters";
import ManualReportList from "../../components/reports/ManualReportList";

const [firstDate, lastDate] = getFirstAndLastDateOfCurrentMonth();

const AccountReceivableHistoryList = () => {
  const { permissions, canSeeCompanyColumn, filterDefaultValues } =
    useCompanyScopedListFilters({
      start_date: firstDate,
      end_date: lastDate,
    });
  const [theme] = useTheme("light");

  const list = useMemo(
    () => (
      <ManualReportList
        storeKey={false} // Disabling Parameters Persistence
        title="mine.list_title.account_receivable_history"
        empty={false}
        // aside={<AccountReceivableHistoryAsideList />}
        actions={<DownloadAction />}
        filters={accountReceivableHistoryFilterList(permissions)}
        filterDefaultValues={filterDefaultValues}
        requiredFilters={["start_date", "end_date"]}
        resetClearsReport
        queryOptions={{ meta: { sort: ["customers.code ASC"] } }} // overide default sort
        sx={{
          flexDirection: "column",
        }}
      >
        <DatagridConfigurable
          // TODO semua data grid yg ada Grand Total harus diganti dengan cara ini
          body={
            <MyDatagridBody footer={<AccountReceivableHistoryFooterList />} />
          }
          bulkActionButtons={false}
          // rowClick={rowClickHandler}
          expandSingle={true}
          isRowExpandable={(row) => Array.isArray(row?.customer_debts) && row.customer_debts.length > 0} // sale_orders jika jenisnya per salesman, sale_items kalau per jenis
          expand={<AccountReceivableHistoryExpandList />}
          sx={{
            "& .RaDatagrid-expandedPanel > td": {
              p: 0,
              bgcolor: theme !== "dark" ? "#E7EBF0" : "grey.800",
            },
          }}
        >
          {canSeeCompanyColumn ? (
            <TextField source="company.alias" label="mine.label.depo" />
          ) : null}
          <TextField
            source="code"
            label="mine.label.code"
            emptyText="-"
            sx={{ width: "5%" }}
          />
          <TextField source="name" label="mine.label.name" />
          <NumberField source="total_pcm" label="PCM" emptyText="0" />
          <NumberField
            source="total_payment"
            label="mine.label.payment"
            emptyText="0"
          />
          <NumberField
            source="total_correction"
            label="mine.label.correction"
            emptyText="0"
          />
          <NumberField
            source="total_remaining_debt"
            label="mine.label.remain"
            emptyText="0"
          />
        </DatagridConfigurable>
      </ManualReportList>
    ),
    [theme, permissions, canSeeCompanyColumn, filterDefaultValues]
  );

  return list;
};

export default AccountReceivableHistoryList;
